import _ from 'lodash';

const DEFAULT_OPTIONS = {
  distance: '20px',
  repeat: false,
  repeatDelay: 3000,
  animation: {
    duration: 800,
    easing: 'ease-in-out',
    fill: 'forwards',
  },
};

export default function (htmlElement, options = {}) {
  const closure = (res, rej) => {
    if (!htmlElement) {
      rej('No element specified for bounce animation.');
    }

    const settings = _.merge(DEFAULT_OPTIONS, options);

    const keyframes = [
      { transform: 'translateY(0)' },
      { transform: `translateY(${settings.distance})` },
      { transform: 'translateY(0)' },
    ];

    const keyframeEffect = new KeyframeEffect(
      htmlElement,
      keyframes,
      settings.animation,
    );

    const animation = new Animation(keyframeEffect, document.timeline);

    animation.addEventListener('finish', () => {
      const { repeat, repeatDelay } = settings;

      if (!repeat) {
        return res(animation);
      }

      setTimeout(() => animation.play(), repeatDelay);
      return res(animation);
    });

    animation.play();
  };

  return new Promise(closure);
}
